import React from 'react';
import { FileTextIcon, GiftIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { TrustStrip } from './TrustStrip';
import { HERO_BODY, HERO_EMPHASIS, HERO_HEADLINE, HERO_KICKER, HERO_SUB, MAIN_MOCKUP, MOCKUP_ALT } from '../data/sushiContent';
const INDICATORS = [{
  Icon: FileTextIcon,
  label: '100% PDF — acceso en 5 min'
}, {
  Icon: GiftIcon,
  label: '3 bonos incluidos'
}, {
  Icon: ShieldCheckIcon,
  label: '7 días de garantía'
}];
export function Hero() {
  return <header className="w-full bg-charcoal-950" data-id="element-161" data-mp="xbpbb0flzqce">
      <div className="mx-auto flex max-w-6xl flex-col px-5 pb-8 pt-6 text-center lg:grid lg:grid-cols-[1.05fr_1fr] lg:grid-rows-[auto_auto] lg:items-center lg:gap-x-14 lg:py-14 lg:text-left" data-id="element-162" data-mp="sbb1bcug66bq">
        <div className="lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-163" data-mp="3d1ikzavvpeny">
          <p className="text-[10px] font-semibold uppercase tracking-[0.32em] text-champagne" data-id="element-164" data-mp="3d2tp5bt8kofl">
            {HERO_KICKER}
          </p>
          <h1 className="mx-auto mt-3 max-w-xl font-display text-[1.6rem] font-semibold leading-tight text-ivory-50 sm:text-[2.1rem] lg:mx-0 lg:mt-4 lg:text-[2.6rem]" data-id="element-165" data-mp="3j8iwex8gcctn">
            {HERO_HEADLINE}
          </h1>

          {HERO_BODY.map(line => <p key={line} className="mx-auto mt-3 max-w-lg text-[13px] leading-relaxed text-body sm:text-[15px] lg:mx-0" data-id="element-166" data-mp="399jppk78yr9a">
              {line}
            </p>)}

          <p className="mx-auto mt-3 max-w-lg font-display text-[1.1rem] italic leading-snug text-champagne sm:text-2xl lg:mx-0" data-id="element-167" data-mp="30gq3t3xaotmg">
            {HERO_EMPHASIS}
          </p>
        </div>

        <img src={MAIN_MOCKUP} alt={MOCKUP_ALT} className="mx-auto my-6 w-full max-w-md object-contain sm:max-w-lg lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:my-0 lg:max-w-none" width={1536} height={1024} data-id="element-168" data-mp="2qleookhz5ke6" />

        <div className="lg:col-start-1 lg:row-start-2 lg:self-start" data-id="element-169" data-mp="2ll0f2y0q62e1">
          <p className="mx-auto max-w-md text-[12.5px] font-medium uppercase tracking-[0.1em] leading-snug text-ivory-200 sm:text-[13px] lg:mx-0 lg:mt-6 lg:max-w-lg" data-id="element-170" data-mp="s21gc6a6u3xc">
            {HERO_SUB}
          </p>

          <ul className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-[10px] font-medium uppercase tracking-[0.14em] text-muted sm:text-[11px] lg:mt-4 lg:justify-start" data-id="element-171" data-mp="ic891hh2wayw">
            {INDICATORS.map(({
            Icon,
            label
          }) => <li key={label} className="flex items-center gap-1.5" data-id="element-172" data-mp="1b0drtyoknpw3">
                <Icon className="h-3 w-3 text-champagne" strokeWidth={1.75} aria-hidden="true" data-id="element-173" data-mp="161jaz2a60bem" />
                {label}
              </li>)}
          </ul>

          <div className="mt-5 flex justify-center lg:justify-start" data-id="element-174" data-mp="x0uwk6gv0917">
            <CtaButton size="md" data-id="element-175" data-mp="3lu0454qihb1b" />
          </div>
          <TrustStrip className="mt-3 lg:justify-start" data-id="element-176" data-mp="3lqm2jypo95ux" />
        </div>
      </div>
    </header>;
}